import React, { FC, useState } from 'react';
import './style.scss';


type SwitchProps = {
    isMonthActive: boolean;
    setisMonthActive: React.Dispatch<React.SetStateAction<boolean>>;
};



const Switch:FC<SwitchProps> = ({
    isMonthActive,
    setisMonthActive
}) => {
  const [isOn, setIsOn] = useState(false);

  const toggle = () => setisMonthActive(!isMonthActive);

  return (
    <div className="toggle-container">
        <span className={`label ${isMonthActive ? 'active text-danger' : ''}`}>Mensuel</span>

      <div className={`switch ${!isMonthActive ? 'on' : ''}`} onClick={toggle}>
        <div className="thumb" />
      </div>

      <span className={`label ${!isMonthActive ? 'active text-primary ' : ''}`}>Annuel</span>
    </div>
  );
};

export default Switch;
